module.exports = {
	"library.navbar.sign_up": "Sign Up",
	"library.navbar.sign_in": "Log In",
	"library.navbar.sign_out": "Log Out",
	"library.navbar.help": "Help",
	"library.navbar.search_for_events": "Search for events",
	"library.navbar.enter_location": "Enter location",
	"library.navbar.find_events": "Find Events",
	"library.navbar.create_event": "Create Event",
	"library.navbar.host_events": "Host Events",
	"library.navbar.dashboard": "Dashboard",
	"library.navbar.my_events": "My Events",
	"library.navbar.my_tickets": "My Tickets",
	"library.navbar.admin_panel": "Admin panel",
	"library.navbar.profile": "Profile",
	"library.navbar.messages": "Messages",
	"library.navbar.settings": "Settings",
	"library.navbar.search_cities": "Search cities",
	"library.navbar.help_center": "Help Center",
	"library.navbar.cant_find_tickets": "Where are my tickets?",
	"library.navbar.contact_organizer": "Contact the event organizer",
	"library.navbar.can_refund": "Can I get a refund?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/en.json
// module id = 1512
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16